import instance from '@apis/instance';
import { PayUInfoResponse } from '@models/easyCard';

class EasyCardApi {
    static getPayUInfo(): Promise<PayUInfoResponse> {
        return instance.get('/easy-card/payu');
    }
}

export default EasyCardApi;
